export function isUndef(val: unknown): val is undefined {
  return val === undefined;
}

export function isNull(val: unknown): val is null {
  return val === null;
}

export function isNullOrUndef(val: unknown): val is undefined | null {
  return val == null;
}

export function isEmpty(val: unknown): val is undefined | null | "" {
  return val === "" || isNullOrUndef(val);
}

/**
 * 获取id
 */
export function getId(prefix?: null): number;
export function getId(prefix: string): string;
export function getId(prefix?: string | null): string | number {
  const ret = -1 - Math.round(Math.random() * 100000000);
  if (isNullOrUndef(prefix)) return ret;
  return `${prefix}${ret}`;
}
